import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import './Image.css'

const Image = ({ src, isContain }) => {
  const styleName = isContain ? 'image contain' : 'image cover'
  return <img src={src} alt="" styleName={styleName} />
}

Image.propTypes = {
  src: PropTypes.string.isRequired,
  isContain: PropTypes.bool.isRequired
}

Image.defaultProps = {
  isContain: false
}

export default compose(pure)(Image)
